/*
Edgeband
--thickness <float> | millimeters
--width <float> | inches
--certification <string::enum> | ['FSC', 'Standard', 'NAUF']
--finish <string::enum> | ['Matte', 'Gloss']
--color <string::enum> | ['White', 'Black']

--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import {
  thickness,
  width,
  certification,
  finish,
  color
} from '@/modules/standardItems/schemas/baseFormFields'
import { manufacturers } from '@/modules/standardItems/schemas/sheetStock/form'

export default [
  color({ classes: ['xs12'] }),
  thickness({ classes: ['xs12', 'sm4', 'input--medium'], autofocus: true, unit: 'millimeters' }),
  width({ classes: ['xs12', 'sm4', 'input--medium'] }),
  certification({ classes: ['xs12', 'sm4', 'input--medium'] }),
  finish({ classes: ['xs12', 'sm4', 'input--medium'] }),
  manufacturers()
]
